var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acesso-widget"},[_c('div',{staticClass:"label"},[_vm._v("Access count")]),_vm._v(" "),_c('div',{staticClass:"count"},[_c('span',{staticClass:"total"},[_vm._v(_vm._s(_vm.total))]),_vm._v(" / "),_c('span',{staticClass:"max"},[_vm._v(_vm._s(_vm.maximo))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f919aed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acessos.vue
// module id = Gtkx
// module chunks = 1